import React, { useMemo, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheck, FiPlus, FiUser, FiX } = FiIcons;

const initialAssignments = [
  {
    id: 1,
    task: 'Confirm ceremony audio requirements',
    category: 'Audio',
    assignee: 'Asi Vidal',
    status: 'In Progress'
  },
  {
    id: 2,
    task: 'Prepare reception timeline and announcements',
    category: 'Production',
    assignee: 'Production team',
    status: 'Not Started'
  },
  {
    id: 3,
    task: 'Collect projection file from client',
    category: 'Visuals',
    assignee: 'Unassigned',
    status: 'Blocked'
  },
  {
    id: 4,
    task: 'Confirm Photo Booth template #12',
    category: 'Photo Booth',
    assignee: 'Production team',
    status: 'Complete'
  }
];

const statusOptions = ['Not Started', 'In Progress', 'Blocked', 'Complete'];

function ProductionAssignmentBoard() {
  const [assignments, setAssignments] = useState(initialAssignments);
  const [showNewTask, setShowNewTask] = useState(false);
  const [newTask, setNewTask] = useState('');

  const completedCount = useMemo(
    () => assignments.filter((item) => item.status === 'Complete').length,
    [assignments]
  );

  const updateAssignment = (id, key, value) => {
    setAssignments((items) => items.map((item) => (
      item.id === id ? { ...item, [key]: value } : item
    )));
  };

  const addAssignment = (event) => {
    event.preventDefault();
    if (!newTask.trim()) return;

    setAssignments((items) => [
      ...items,
      {
        id: Date.now(),
        task: newTask.trim(),
        category: 'Production',
        assignee: 'Unassigned',
        status: 'Not Started'
      }
    ]);
    setNewTask('');
    setShowNewTask(false);
  };

  return (
    <section className="panel" style={{ padding: 22 }}>
      <div className="summary-title">
        <div>
          <span className="number">05</span>
          <h2>Production assignments</h2>
        </div>
        <button
          className="button secondary"
          onClick={() => setShowNewTask((value) => !value)}
        >
          <SafeIcon icon={showNewTask ? FiX : FiPlus} />
          {showNewTask ? 'Cancel' : 'Add task'}
        </button>
      </div>

      <div className="detail-facts" style={{ margin: '0 0 18px', gridTemplateColumns: 'repeat(3, 1fr)' }}>
        <div>
          <small>Total tasks</small>
          <strong>{assignments.length}</strong>
        </div>
        <div>
          <small>Completed</small>
          <strong>{completedCount}</strong>
        </div>
        <div>
          <small>Open items</small>
          <strong>{assignments.length - completedCount}</strong>
        </div>
      </div>

      {showNewTask && (
        <form onSubmit={addAssignment} style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
          <input
            autoFocus
            required
            value={newTask}
            onChange={(event) => setNewTask(event.target.value)}
            placeholder="Add a production task"
            style={{
              flex: 1,
              minHeight: 43,
              padding: '10px 12px',
              border: '1px solid var(--line)',
              borderRadius: 8
            }}
          />
          <button className="button primary">Add task</button>
        </form>
      )}

      <div style={{ display: 'grid', gap: 9 }}>
        {assignments.map((item) => (
          <div
            key={item.id}
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 145px 145px 125px',
              gap: 10,
              alignItems: 'center',
              padding: 12,
              background: '#fafaf8',
              border: '1px solid var(--line)',
              borderRadius: 9
            }}
          >
            <div>
              <strong style={{ display: 'block', fontSize: 12 }}>{item.task}</strong>
              <span style={{ color: 'var(--muted)', fontSize: 10 }}>{item.category}</span>
            </div>

            <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <SafeIcon icon={FiUser} />
              <select
                value={item.assignee}
                onChange={(event) => updateAssignment(item.id, 'assignee', event.target.value)}
                style={{ width: '100%', border: 0, background: 'transparent', fontSize: 11 }}
              >
                <option>Unassigned</option>
                <option>Asi Vidal</option>
                <option>Production team</option>
                <option>DJ team</option>
                <option>AV team</option>
              </select>
            </label>

            <select
              value={item.status}
              onChange={(event) => updateAssignment(item.id, 'status', event.target.value)}
              style={{ minHeight: 34, padding: '0 8px', border: '1px solid var(--line)', borderRadius: 7, fontSize: 11 }}
            >
              {statusOptions.map((status) => <option key={status}>{status}</option>)}
            </select>

            {item.status === 'Complete' ? (
              <span className="check-item" style={{ margin: 0 }}>
                <SafeIcon icon={FiCheck} /> Complete
              </span>
            ) : (
              <span style={{ color: 'var(--muted)', fontSize: 10 }}>Needs attention</span>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}

export default ProductionAssignmentBoard;